import BookStore from '../stores/book-store';
import BookmarkStore from '../stores/bookmark-store';

export default {

  bookmarkExists: function(isbn) {
    // TODO refactor this
    let i;
    let book = BookStore.get(isbn);
    let bookmarks = BookmarkStore.getAll(isbn).bookmarks;
    switch (book.vbkType){
      case "epub":
        let currentCFI = Fraction.Helpers.stripScrollPosition(book.lastCFI).split("!").reverse()[0];
        for (i=0;i < bookmarks.length;i++){
          let bookmarkCFI = Fraction.Helpers.stripScrollPosition(bookmarks[i].epubCfi).split("!").reverse()[0];
          if (currentCFI===bookmarkCFI.split("!").reverse()[0]){
            return true;
          }
        }
        return false;
      case "dash":
        return false;
      case "pbk":
        for (i=0;i < bookmarks.length;i++){
          if (book.currentPage===bookmarks[i].page){
            return true;
          }
        }
        break;
    }

    return false;
  }

};
